<template>
  <div class="v--modal-box v--modal vue-dialog">
    <div class="dialog-content">
      <div class="dialog-c-title">Частичная оплата заказа № {{order.SferaNumber}}. Стоимость заказа: {{order.Summary}}</div>
      <div class="dialog-c-text">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">Полученная сумма</span>
          </div>
          <input type="number" v-model="partAmount" class="form-control" placeholder="" required>
        </div>
      </div>
    </div>
    <div class="vue-dialog-buttons">
      <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click.prevent="submit">ОК</button>
      <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="$emit('close')">Отмена</button>
    </div>
    <v-dialog @closed="$emit('close')"/>
  </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';

const url = process.env.VUE_APP_API_HOST;
export default {
  props: {
    orderItemId: Number,
  },
  data() {
    return {
      order: {},
      partAmount: 0,
    };
  },
  async mounted() {
    await this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      const { data } = await get(`${url}admin/order/${this.orderItemId}`);
      this.order = data;
    },
    async submit() {
      try {
        await post(`${process.env.VUE_APP_API_HOST}admin/order/make-part-paid-order`,
          {
            orderItemId: this.orderItemId,
            partAmount: this.partAmount,
          });
          this.$toasted.show('Выполнено', { type: 'success' });
          this.$emit('close');
      } catch (e) {
        this.$toasted.show('Ошибка', { type: 'error' });
      }

      // console.log({ OrderId: this.order.Id, Message: this.message });
      // await post(`${url}admin/recast-request`, { OrderItemId: this.order.Id, Message: this.message });
      // this.$modal.show('dialog', {
      //   title: 'Запрос отправлен!',
      // }, {
      //   pivotY: 0.2,
      // });
    },
  },
};
</script>
